import React from 'react';
import { Skeleton } from '@mui/material';
import classes from './scss/tifoSkeleton.module.scss';
import { useWindowSize } from '../../../utils/hooks';
import { responsiveSizeTIFO } from '../../../utils/constants';
import colors from '../../../scss/colors';

function TIFOSkeleton() {
  const size = useWindowSize();

  return (
    <div style={{ width: '100%', height: '100%' }} className={classes.mainContainer}>
      <div className={classes.header}>
        <div className={classes.left}>
          {size.width > responsiveSizeTIFO ? (
            <>
              <Skeleton width={56} height={80} />
              <Skeleton width={56} height={80} />
              <Skeleton width={56} height={80} />
              <Skeleton width={56} height={80} />
            </>
          ) : null}
        </div>
        <Skeleton width={56} height={80} />
      </div>
      <div className={classes.yellowLabel}>
        <Skeleton width={176} height={40} />
      </div>
      <div className={classes.tableContainer}>
        <div className={classes.tableWithHeader}>
          <div className={classes.tableHeader}>
            <Skeleton width={195} height="40px" />
          </div>
          <div className={classes.table}>
            {size.width > responsiveSizeTIFO ? (
              <div className={classes.headOfTable}>
                <Skeleton variant="text" width="100%" height="40px" />
              </div>
            ) : null}
            {Array.from({ length: 20 }, (v, k) => k).map((_, idx) =>
              size.width > responsiveSizeTIFO ? (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx} className={classes.rowOfTable}>
                  <Skeleton variant="text" width="100%" height="40px" />
                </div>
              ) : (
                // eslint-disable-next-line react/no-array-index-key
                <div key={idx} className={classes.rowCardOfTable}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="40px"
                    sx={{ border: `1px solid ${colors.LIGHT_GREY}` }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="40px"
                    sx={{ border: `1px solid ${colors.LIGHT_GREY}` }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="40px"
                    sx={{ border: `1px solid ${colors.LIGHT_GREY}` }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="40px"
                    sx={{ border: `1px solid ${colors.LIGHT_GREY}` }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="40px"
                    sx={{ border: `1px solid ${colors.LIGHT_GREY}` }}
                  />
                  <div className={classes.bottomPart}>
                    <Skeleton variant="rectangular" width="100%" height="40px" />
                    <Skeleton
                      width="50%"
                      height="40px"
                      sx={{
                        backgroundColor: colors.LIGHTER_GREY,
                        position: 'absolute',
                        top: '0px',
                        right: '8px'
                      }}
                    />
                  </div>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="40px"
                    sx={{ border: `1px solid ${colors.LIGHT_GREY}` }}
                  />
                  <div className={classes.bottomPart}>
                    <Skeleton variant="rectangular" width="100%" height="40px" />
                    <Skeleton
                      width="50%"
                      height="40px"
                      sx={{
                        backgroundColor: colors.PRIMARY_BLUE,
                        position: 'absolute',
                        top: '0px',
                        right: '8px'
                      }}
                    />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TIFOSkeleton;
